import React, {useState} from 'react';
import Box from "@mui/material/Box";
import ShopItem from "./ShopItem";
import {FormGroup, Grid} from "@mui/material";
import "./GeneralShop.css"
import CheckoutForm from "./Checkout";

export default function GeneralShop(props) {

    // toggle checks
    const [checked, setChecked] = useState([])
    const [expanded, setExpanded] = useState([])
    const [choiceMap, setChoiceMap] = useState({})

    const toggleChecked = (id, isOn) => {
        setChecked(prev => (isOn ? [...prev, id] : prev.filter(x => x !== id)))
    }

    const toggleExpanded = id => {
        setExpanded(prev => (prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]))
    }

    const onChoiceChange = (id, choiceIdx) => {
        setChoiceMap(prev => ({...prev, [id]: choiceIdx}))
    }


    return (
        <Grid container spacing={2} maxWidth="lg" sx={{mt: 4}}>
            <Grid item xs={12} md container               // now this grid‐cell is also a flex container
                  justifyContent="center" // horizontal centering
                  alignItems="flex-start"     // vertical centering (if you have a fixed height or rows)
            >
                <Box
                    className="flexColumnCenter general_shop_container"
                    sx={{
                        width: '100%',      // fill its grid cell
                        minHeight: 0,     // allow inner scroll if you need it
                        maxWidth: "580px"
                    }}
                >
                    {props.data.map((item) => (
                        <ShopItem
                            key={item.id}
                            id={item.id}
                            itemTitle={item.title}
                            price={item.price}
                            content={item.content}
                            options={item.options}
                            checked={checked.includes(item.id)}
                            expanded={expanded.includes(item.id)}
                            defaultChoice={choiceMap[item.id] || 0}
                            onToggleChecked={toggleChecked}
                            onToggleExpanded={toggleExpanded}
                            onChoiceChange={onChoiceChange}
                        />

                    ))}
                </Box>
            </Grid>
            <Grid item xs={12} md="auto"  container               // now this grid‐cell is also a flex container
                  justifyContent="center" // horizontal centering
                  alignItems="center"   >
                <Box
                    className="flexRowCenter"
                    sx={{
                        maxWidth: 580,
                        width: '100%'       // fill its grid cell
                    }}
                >
                    <CheckoutForm checked={checked} choiceMap={choiceMap} data={props.data} ></CheckoutForm>
                </Box>
            </Grid>
        </Grid>

    );
}

